import React from "react";

// Import SCSS
import styles from "./DataCenterAndLocationsPage.module.scss";

// Import Components
import HeroComponent from "../../../../Layout/Components/HeroComponent/HeroComponent";
import AboutUsComponent from "./Components/AboutUsComponent/AboutUsComponent";
import WhyChooseUsComponent from "./Components/WhyChooseUsComponent/WhyChooseUsComponent";
import NetworkInfoComponent from "./Components/NetworkInfoComponent/NetworkInfoComponent";
import RevolvingLogoComponent from "./Components/RevolvingLogoComponent/RevolvingLogoComponent";

// Import Animation
import FadeInOnScroll from "../../../../util/Animations/FadeInOnScroll";
import TestNetworkSpeedsComponent from "../../DedicatedServersTab/StandardServersPage/Components/TestNetworkSpeedsComponent/TestNetworkSpeedsComponent";
import ImageComponent from "./Components/ImageComponent/ImageComponent";

const DataCenterAndLocationsPage = ({ location }) => {
  return (
    <div className={styles.dataCenterAndLocationsPage}>
      {/* Page Components with Fade-In Animation */}
      <FadeInOnScroll>
        <NetworkInfoComponent location={location} />
      </FadeInOnScroll>

      <FadeInOnScroll>
        <ImageComponent />
      </FadeInOnScroll>

      <FadeInOnScroll>
        <RevolvingLogoComponent />
      </FadeInOnScroll>

      <FadeInOnScroll>
        <TestNetworkSpeedsComponent />
      </FadeInOnScroll>

      <FadeInOnScroll>
        <WhyChooseUsComponent />
      </FadeInOnScroll>
    </div>
  );
};

export default DataCenterAndLocationsPage;
